import { gql } from 'graphql-request';

export const CREATE_PLANTING_PRESCTIPTION_MUTATION = gql`
  mutation ($input: PlantingPrescriptionGenerationInput!) {
    generatePlantingPrescription(input: $input) {
      id
      status
      errorCode
      errorMessage
      result {
        zones {
          ... on PlantingZone {
            id
            geometry
            seedingRate {
              u
              v
            }
            targetYield {
              u
              v
            }
            product {
              id
              name
              brand {
                name
              }
            }
            area {
              u
              v
            }
          }
        }
        activityType
      }
    }
  }
`;
